<div class="popup-container">
  <h3 class="title">Something Went Wrong</h3>
  <p class="message">{{ transactionErrorMsg }}</p>
  <button (click)="onBackClicked()" class="btn-primary small">BACK</button>
</div>
